import { bidirectionalFlowmeterElementConfig } from "./bidirectionalFlowmeterSensorElement.js";
import { boardTemperatureElementConfig } from "./boardTemperatureSensorElement.js";
import { flowmeterElementConfig } from "./flowmeterSensorElement.js";
import { humidityElementConfig } from "./humiditySensorElement.js";
import { imperialBarometricPressureElementConfig } from "./imperialBarometricPressureSensorElement.js";
import { imperialEvapotranspirationElementConfig } from "./imperialEvapotranspirationSensorElement.js";
import { inclinationAngleElementConfig, inclinationDirectionElementConfig } from "./inclinationSensorElement.js";
import { liquidTankLevelElementConfig } from "./liquidTankLevelSensorElement.js";
import { outputOperatingModeElementConfig } from "./outputOperatingModeSensorElement.js";
import { outputPositionElementConfig } from "./outputPositionSensorElement.js";
import { pressureTransducerElementConfig } from "./pressureTransducerSensorElement.js";
import { pulseTotalizerElementConfig } from "./pulseTotalizerSensorElement.js";
import {
    digitalCodeElementConfig,
    digitalCountElementConfig,
    digitalPercentageElementConfig,
    digitalPrecipitationElementConfig,
    digitalVoltageElementConfig,
} from "./simpleDigitalSensorElements.js";
import { soilTemperatureElementConfig } from "./soilTemperatureSensorElement.js";
import { soilTensionElementConfig } from "./soilTensionSensorElement.js";
import { solarRadiationElementConfig } from "./solarRadiationSensorElement.js";
import {
    saplingVerificationElementConfig,
    solenoidVerificationElementConfig,
} from "./solenoidVerificationSensorElement.js";
import { stemRadiusChangeElementConfig } from "./stemRadiusChangeSensorElement.js";
import { imperialTemperatureElementConfig, temperatureElementConfig } from "./temperatureSensorElement.js";
import { SensorElementConfig } from "./types.js";
import { uvIndexElementConfig } from "./uvIndexSensorElement.js";
import { volumetricWaterContentElementConfig } from "./volumetricWaterContentSensorElement.js";
import {
    imperialWindGustElementConfig,
    imperialWindSpeedElementConfig,
    windHeadingElementConfig,
} from "./windSensorElements.js";
import {
    zoneIrrigationScheduledElementConfig,
    zoneNdviElementConfig,
    zoneNdviVarianceElementConfig,
} from "./zoneVirtualSensorElements.js";

export const sensorElementConfigs = {
    // Physical external sensors
    flowmeter: flowmeterElementConfig,
    bidirectionalFlowmeter: bidirectionalFlowmeterElementConfig,
    pressureTransducer: pressureTransducerElementConfig,
    pulseTotalizer: pulseTotalizerElementConfig,
    volumetricWaterContent: volumetricWaterContentElementConfig,
    liquidTankLevel: liquidTankLevelElementConfig,

    // Physical internal sensors
    temperature: temperatureElementConfig,
    imperialTemperature: imperialTemperatureElementConfig,
    boardTemperature: boardTemperatureElementConfig,
    soilTemperature: soilTemperatureElementConfig,
    soilTension: soilTensionElementConfig,
    humidity: humidityElementConfig,

    // Device output state and diagnostics
    outputPosition: outputPositionElementConfig,
    outputOperatingMode: outputOperatingModeElementConfig,
    solenoidVerification: solenoidVerificationElementConfig,
    saplingVerification: saplingVerificationElementConfig,

    // Zone virtual sensors
    zoneNdvi: zoneNdviElementConfig,
    zoneNdviVariance: zoneNdviVarianceElementConfig,
    zoneIrrigationScheduled: zoneIrrigationScheduledElementConfig,

    // Simple digital sensor elements — generic reusable building blocks
    digitalCount: digitalCountElementConfig,
    digitalVoltage: digitalVoltageElementConfig,
    digitalPercentage: digitalPercentageElementConfig,
    digitalCode: digitalCodeElementConfig,
    digitalPrecipitation: digitalPrecipitationElementConfig,

    // Physical environmental sensors
    stemRadiusChange: stemRadiusChangeElementConfig,
    inclinationAngle: inclinationAngleElementConfig,
    inclinationDirection: inclinationDirectionElementConfig,
    solarRadiation: solarRadiationElementConfig,

    // Weather station sensors
    imperialWindSpeed: imperialWindSpeedElementConfig,
    imperialWindGust: imperialWindGustElementConfig,
    windHeading: windHeadingElementConfig,
    imperialBarometricPressure: imperialBarometricPressureElementConfig,
    uvIndex: uvIndexElementConfig,
    imperialEvapotranspiration: imperialEvapotranspirationElementConfig,
} satisfies Record<string, SensorElementConfig<any>>;
